<div class="input-group input-icon {{ classes }}">
    <span class="icon" [ngClass]="{ 'i-eye': showPassword, 'i-eye-close': !showPassword }" (click)="toggleInputType()"></span>
    <input
        [type]="type"
        class="password-input"
        [id]="inputId"
        [value]="value"
        (input)="onInput()"
        (blur)="markAsTouched()"
        [placeholder]="placeholder | translate"
        [formControl]="inputControl"
        [ngClass]="!isValid && touched ? 'invalid-control' : ''"
    />
</div>
<div class="errors">
    <ng-content></ng-content>
</div>
